import { getAccessToken } from './session';

export default function authHeader() {
  const token = getAccessToken();
  return token ? { 'x-access-token': token } : {};
}
